var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyEmergencyItems(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_398_4560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3268 7.65926H15.3823V4.93091H20.3268V7.65926Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1831 4.93091H17.5386V6.9261H16.1831V4.93091Z",
    fill: "#D0CFD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.67328 4.93091H6.61771V7.65926H1.67328V4.93091Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.47406 4.93091H3.82959V6.9261H2.47406V4.93091Z",
    fill: "#D0CFD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8954 5.1779H13.1248V2.91499C13.1248 2.71039 12.9584 2.54405 12.7538 2.54405H9.24617C9.04156 2.54405 8.87523 2.71039 8.87523 2.91499V5.1779H7.10461V2.91499C7.10461 1.73419 8.06537 0.773438 9.24617 0.773438H12.7538C13.9346 0.773438 14.8954 1.73419 14.8954 2.91499V5.1779Z",
    fill: "#A6B6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.10461 3.09741H8.87523V5.17787H7.10461V3.09741Z",
    fill: "#7A8FA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1248 3.09741H14.8954V5.17787H13.1248V3.09741Z",
    fill: "#7A8FA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4944 4.42529H20.0317C19.7524 4.42529 19.5261 4.65172 19.5261 4.93102V6.27278C19.5261 6.57155 19.2837 6.81392 18.985 6.81392H16.7242C16.4253 6.81392 16.1831 6.57172 16.1831 6.27278V4.93102C16.1831 4.65172 15.9567 4.42529 15.6774 4.42529H6.32262C6.04332 4.42529 5.81689 4.65172 5.81689 4.93102V6.27278C5.81689 6.57155 5.57469 6.81392 5.27576 6.81392H3.0152C2.71626 6.81392 2.47406 6.57172 2.47406 6.27278V4.93102C2.47406 4.65172 2.24763 4.42529 1.96834 4.42529H0.505554C0.226425 4.42529 0 4.65172 0 4.93102V19.6658C0 20.5235 0.695389 21.2189 1.55309 21.2189H20.4469C21.3046 21.2189 22 20.5235 22 19.6658V4.93102C22 4.65172 21.7736 4.42529 21.4944 4.42529Z",
    fill: "#FF889E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.328 19.6658V4.93109C1.328 4.65179 1.55426 4.42554 1.83356 4.42554H0.505554C0.226425 4.42537 0 4.65179 0 4.93109V19.6658C0 20.5235 0.695389 21.2189 1.55309 21.2189H2.88109C2.02339 21.2189 1.328 20.5235 1.328 19.6658V19.6658Z",
    fill: "#F9496E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6204 8.9082H3.37962C2.73543 8.9082 2.21326 9.43037 2.21326 10.0746V17.8393C2.21326 18.4835 2.73543 19.0057 3.37962 19.0057H18.6206C19.2646 19.0057 19.7868 18.4835 19.7868 17.8393V10.0746C19.7868 9.43037 19.2646 8.9082 18.6204 8.9082V8.9082Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.54126 17.8393V10.0746C3.54126 9.43037 4.06343 8.9082 4.70763 8.9082H3.37962C2.73543 8.90837 2.21326 9.43037 2.21326 10.0746V17.8393C2.21326 18.4835 2.73543 19.0057 3.37962 19.0057H4.70763C4.06343 19.0057 3.54126 18.4835 3.54126 17.8393V17.8393Z",
    fill: "#D0CFD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5504 12.9592H11.9977V11.4065C11.9977 11.18 11.8142 10.9966 11.5878 10.9966H10.4124C10.1859 10.9966 10.0023 11.18 10.0023 11.4065V12.9592H8.44955C8.22313 12.9592 8.03967 13.1428 8.03967 13.3693V14.5447C8.03967 14.7711 8.22313 14.9546 8.44955 14.9546H10.0023V16.5073C10.0023 16.7337 10.1859 16.9174 10.4124 16.9174H11.5878C11.8142 16.9174 11.9977 16.7337 11.9977 16.5073V14.9546H13.5504C13.7768 14.9546 13.9605 14.7711 13.9605 14.5447V13.3693C13.9605 13.1428 13.7768 12.9592 13.5504 12.9592V12.9592Z",
    fill: "#F9496E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_398_4560"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyEmergencyItems);
export default __webpack_public_path__ + "static/media/MyEmergencyItems.c05f74a34f115f4ed2b0f7dc453b4495.svg";
export { ForwardRef as ReactComponent };